export default __webpack_public_path__ + "35d11ae20db150d2203bd14e286dc8ec.svg";